import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Servicio } from 'src/app/models/Servicio';
import { UsuarioService } from 'src/app/services/usuario.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-my-account-servicios',
    templateUrl: './my-account-servicios.component.html',
    styleUrls: ['./my-account-servicios.component.css'],
    standalone: false
})
export class MyAccountServiciosComponent implements OnInit{
  private _router = inject(Router);
  private _location = inject(Location);

  private _usuarioService = inject(UsuarioService);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);

  // estado
  servicios = signal<Servicio[]>([]);
  error = signal<string>('');
  message = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
        return;
      }

      await this.loadServicios();
    });
  }

  private async loadServicios(): Promise<void> {
    this.error.set('');

    try {
      const res = await firstValueFrom(
        this._usuarioService.getServicios(this._usuarioService.usuario().id!)
      );
      this.servicios.set(res ?? []);
    } catch (e: any) {
      console.error(e);
      this.error.set('Error al obtener los servicios.');
    }
  }

  async activarDesactivar(servicio: Servicio, checked: boolean): Promise<void> {
    this.error.set('');
    this.message.set('');

    // clonar para no romper UI si falla
    const prevActivo = !!servicio.b_activo;
    const descEsp = servicio.descripcionEspecialidad;
    const descPre = servicio.descripcionPrestacion;

    // update optimista
    servicio.b_activo = checked;
    this.servicios.set([...this.servicios()]);

    await this._loadingService.run(async () => {
      try {
        await firstValueFrom(this._usuarioService.updateServicio(servicio));

        // reponer descripciones si el backend las pisa
        servicio.descripcionEspecialidad = descEsp;
        servicio.descripcionPrestacion = descPre;

        this.message.set('Modificación realizada correctamente');
        setTimeout(() => this.message.set(''), 2500);
      } catch (e) {
        console.error(e);

        // rollback
        servicio.b_activo = prevActivo;
        servicio.descripcionEspecialidad = descEsp;
        servicio.descripcionPrestacion = descPre;
        this.servicios.set([...this.servicios()]);

        this.error.set('Error al realizar la modificación');
      }
    });
  }

  back() {
    this._location.back();
  }
}
